import { render, staticRenderFns } from "./TbFilaAndamento.vue?vue&type=template&id=44b76b8f&scoped=true"
import script from "./TbFilaAndamento.vue?vue&type=script&lang=js"
export * from "./TbFilaAndamento.vue?vue&type=script&lang=js"
import style0 from "./TbFilaAndamento.vue?vue&type=style&index=0&id=44b76b8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b76b8f",
  null
  
)

export default component.exports